import React from 'react';
import { motion } from 'framer-motion';
// Helper for class names
function cn(...classes: (string | undefined | null | false)[]) {
  return classes.filter(Boolean).join(' ');
}
export const LampContainer = ({
  children,
  className
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  return <div className={cn('relative flex min-h-[70vh] flex-col items-center justify-center overflow-hidden bg-deep-dark w-full rounded-md z-0', className)} data-id="element-126">
      <div className="relative flex w-full flex-1 scale-y-125 items-center justify-center isolate z-0 " data-id="element-127">
        <motion.div initial={{
        opacity: 0.5,
        width: '15rem'
      }} whileInView={{
        opacity: 1,
        width: '30rem'
      }} transition={{
        delay: 0.3,
        duration: 0.8,
        ease: 'easeInOut'
      }} style={{
        backgroundImage: `conic-gradient(var(--conic-position), var(--tw-gradient-stops))`
      }} className="absolute inset-auto right-1/2 h-56 overflow-visible w-[30rem] bg-gradient-to-br from-neon-cyan via-transparent to-transparent text-white [--conic-position:from_70deg_at_center_top]" data-id="element-128">
          <div className="absolute  w-[100%] left-0 bg-deep-dark h-40 bottom-0 z-20 [mask-image:linear-gradient(to_top,white,transparent)]" data-id="element-129" />
          <div className="absolute  w-40 h-[100%] left-0 bg-deep-dark  bottom-0 z-20 [mask-image:linear-gradient(to_right,white,transparent)]" data-id="element-130" />
        </motion.div>
        <motion.div initial={{
        opacity: 0.5,
        width: '15rem'
      }} whileInView={{
        opacity: 1,
        width: '30rem'
      }} transition={{
        delay: 0.3,
        duration: 0.8,
        ease: 'easeInOut'
      }} style={{
        backgroundImage: `conic-gradient(var(--conic-position), var(--tw-gradient-stops))`
      }} className="absolute inset-auto left-1/2 h-56 w-[30rem] bg-gradient-to-bl from-transparent via-transparent to-neon-cyan text-white [--conic-position:from_290deg_at_center_top]" data-id="element-131">
          <div className="absolute  w-40 h-[100%] right-0 bg-deep-dark  bottom-0 z-20 [mask-image:linear-gradient(to_left,white,transparent)]" data-id="element-132" />
          <div className="absolute  w-[100%] right-0 bg-deep-dark h-40 bottom-0 z-20 [mask-image:linear-gradient(to_top,white,transparent)]" data-id="element-133" />
        </motion.div>
        <div className="absolute top-1/2 h-48 w-full translate-y-12 scale-x-150 bg-deep-dark blur-2xl" data-id="element-134"></div>
        <div className="absolute top-1/2 z-50 h-48 w-full bg-transparent opacity-10 backdrop-blur-md" data-id="element-135"></div>
        <div className="absolute inset-auto z-50 h-36 w-[28rem] -translate-y-1/2 rounded-full bg-neon-cyan opacity-50 blur-3xl" data-id="element-136"></div>
        <motion.div initial={{
        width: '8rem'
      }} whileInView={{
        width: '16rem'
      }} transition={{
        delay: 0.3,
        duration: 0.8,
        ease: 'easeInOut'
      }} className="absolute inset-auto z-30 h-36 w-64 -translate-y-[6rem] rounded-full bg-neon-cyan blur-2xl" data-id="element-137"></motion.div>
        <motion.div initial={{
        width: '15rem'
      }} whileInView={{
        width: '30rem'
      }} transition={{
        delay: 0.3,
        duration: 0.8,
        ease: 'easeInOut'
      }} className="absolute inset-auto z-50 h-0.5 w-[30rem] -translate-y-[7rem] bg-neon-cyan " data-id="element-138"></motion.div>

        <div className="absolute inset-auto z-40 h-44 w-full -translate-y-[12.5rem] bg-deep-dark " data-id="element-139"></div>
      </div>

      <div className="relative z-50 flex -translate-y-80 flex-col items-center px-5" data-id="element-140">
        {children}
      </div>
    </div>;
};